import LoadCreationResultTable from './loads-creation-result-table';

export default LoadCreationResultTable;
